import React, { Component } from 'react';
import { Progress, Table, Row, Button} from 'reactstrap';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import getTooltipStyles from '../../../shared/helpers';
import { Link } from "react-router-dom";
import Fab from "@material-ui/core/Fab";


import Panel from '../../../shared/components/Panel';

import { _getClosedSales, _getTract, _getTopAgents } from './apicalls';

import SubFilter from './SubFilter';
import { searchBarStyles } from '../../../shared/helpers/utils';
import GeneralBuildingSearchBar from "../../../shared/components/building_filters/GeneralBuildingSearchBar";
import ToggleChips from './ToggleChips';


import { 
	_agentFilters	
} from "./filters";

const colors = {
	Low: '#ff4861',
	Moderate: '#f6da6e',
    Middle: '#70bbfd',
    Upper: '#4ce1b6',
};

const chipData = [
 { key: 0, label: "Most Transactions" },
   { key: 1, label: "Condo Specialists" },
   { key: 2, label: "Co-op Experts" },
   { key: 3, label: "Luxury Market Leaders" },
   { key: 4, label: "New Development Brokers" },
   { key: 5, label: "International Experience" },
   { key: 6, label: "Top Buyer Agents" },
   { key: 7, label: "Top Listing Agents" },
   { key: 9, label: "Investor-Focused Brokers" },
   { key: 16, label: "Ultra Luxury Brokers" },
   { key: 19, label: "Townhouse Specialists" },
   { key: 17, label: "Historic & Landmark Property Experience" }
];

class TopAgents extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    themeName: PropTypes.string.isRequired,
  };
 
  
  constructor() {
    super();
    this.state = {
      data: false,
    };
  }

  
  componentDidMount() {
	const query = '*:*';
	const lenderData = [];
	const { type } = this.props;  
	console.log(type);
	_getTopAgents(query, type, { callback: (result) => { 
		
		console.log(result);
		result = result.filter((agent, index, self) => index === self.findIndex((t) => (t.email === agent.email)));	
		this.setState({ data: result.slice(0, 10) });

	} });
  }
  
  shouldComponentUpdate(nextProps, nextState) {
	  
	  const { type } = this.props;
	  return type !== nextProps.type || JSON.stringify(this.state.data) !== JSON.stringify(nextState.data);
  }
  
  componentDidUpdate() {
	 const { type } = this.props;
	 const query = '*:*';

	_getTopAgents(query, type, { callback: (result) => { 
		
		console.log(result);
		result = result.filter((agent, index, self) => index === self.findIndex((t) => (t.email === agent.email)));	
		this.setState({ data: result.slice(0, 25) });

	} });
  }
  
  _pickBanks = (lenders) => {
	  const banks = [
		 { name : 'first republic', match: 'first' },
		 { name : 'wells fargo', match: 'wells' },
		 { name : 'citizens', match: 'citizens' },
		 { name : 'td bank', match: 'td' },
		 { name : 'jp morgan', match: 'jp' },
	  ];
	  
	  const stats = { 
		  'first republic' : 0,
		  'wells fargo': 0,
		  'citizens': 0,
		  'td bank': 0,
		  'jp morgan': 0 
	  };	  
	  for(let i = 0; i < lenders.length; i++) {
		  const lender = lenders[i];
		  banks.map(bank => {
			  if(lender.val.indexOf(bank.match) >= 0) {
				  stats[bank.name] += lender.total;
			  }
			  return null;
		  });
		  
	  }	  
	  return stats;
	  
  }
   _toggle = (source) => {
	  let checkboxes = document.getElementsByName('add');
	  for(var i=0, n=checkboxes.length;i<n;i++) {
	    checkboxes[i].checked = source.currentTarget.checked;
	  }
	}
	
  render() {
      const { t, dir, themeName, type, title, subhead } = this.props;    
      const { data } = this.state;
	  if(!data) return null;
	  const profileColors = ['#9decd6', '#9eb3c1', '#f9b2b2', '#66abf5'];
	  
	  return (
		  <Panel 
		  	md={12}
		  	lg={12}
		  	xl={12} 
		  	title={title}
		  	subhead={subhead}
		  >
		  	<GeneralBuildingSearchBar
				  buildingFilter={
					'(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
				  }
				  handleSearch={null}
				  buildingAttributes={[]}
				  placeHolder={
					"Search Brokers by Firm, Area of Focus or Use the Map"
				  }
				  addBuilding={true}
				  buildingTab={null}
				  hideBoroHood={false}
				  hideAddIcon={false}
				  hideMapDraw={false}
				  searchBarStyles={searchBarStyles}

				/>
			 <ToggleChips chipData={chipData} />
		  	 <SubFilter _filters={_agentFilters} subFilters={{}} />
		  	 <div style={{textAlign:"right"}}>
		  		 <Button color="primary" type="submit" style={{fontSize:12,margin:"0px 0px 10px 0"}}>Create Broker List</Button>
		  		 
		  	 </div>
		     <Table responsive striped className="dashboard__table-orders">
		      <thead>
		        <tr>
		          <th style={{whiteSpace:'nowrap'}}><input type="checkbox" onClick={(e) => this._toggle(e)} /></th>
		          <th>Agent</th>
		          <th>Firm</th>
		          <th>Phone</th>
		          <th>Email</th>
		          <th>Total Transactions</th>
		          <th></th>
		        </tr>
		      </thead>
		      <tbody>
		        {data.map((agent, i) => (
		          <tr key={agent.key}>
		          	<td><input type="checkbox" name="add" /></td>
		            <td className="dashboard__table-orders-title">
		              <div className="dashboard__table-orders-img-wrap">
		              	{agent.image
		                	? <div className="dashboard__table-orders-img" style={{ backgroundImage: `url(${agent.image ? agent.image : "/img/ava.png"})` }} />
		                	: <div className="dashboard__table-orders-img" style={{ background: profileColors[Math.floor(Math.random() * profileColors.length)], textAlign: 'center', lineHeight: '32px', fontSize:'15px', color: '#FFF' }}>{agent.display_name[0]}</div>
		                }
		              </div>
		              <div>{agent.display_name}<br/>
		              		<a href="" style={{marginTop:5,fontSize:11}}>See Profile &raquo;</a>
		              </div>
		              
		            </td>
		            <td style={{ textTransform: 'capitalize' }}>
		              {agent.company_name.toLowerCase().replace('llc', '').replace(',', '').replace('.', '')}
		            </td>
		            <td>{agent.phone}</td>
		            <td><a href={`mailto:${agent.email}`}>{agent.email}</a></td>
		            <td>
			            <div className="progress-wrap progress-wrap">
			              <span style={{marginBottom:6, display:'inline-block', fontSize:'11px', textTransform:'lowercase' }}> {agent.count} in past 12 months</span>
			              <Progress value={(agent.count)} />
			            </div>
			        </td>
			        <td><Button color="primary" type="submit" style={{fontSize:12,margin:"0px 20px"}}>Contact</Button></td>
						
		          </tr>
		        ))}
		      </tbody>
		    </Table>
			<Link to={`/`} className="see-more">See More &raquo;</Link>
			
		  </Panel>
		);
	}
}

export default connect(state => ({
  rtl: state.rtl,
  theme: state.theme,
}))(withTranslation('common')(TopAgents));
